<div *ngIf="question">

    <span *ngIf="explanations.length > 0">
        <div>
            <h3 class='text-center gold-bg'> Solution </h3>
            <div class='bg-light'>
                <span *ngFor="let explanation of explanations;index as myCount">

                    <p *ngIf="explanation.is_media_present!=1" class='answer-step' [innerHtml]="explanation.body"
                        [appMath]="explanation.body"></p>
                    <span *ngIf="explanation.is_media_present==1">
                        <app-image-answer-explanation
                            *ngFor="let myImage of explanation.media_file_info"
                            [questionId]="question.server_question_id"
                            [mediaFileName]="myImage.media_file_name"
                            [explanationPartName]="explanation.name">
                        </app-image-answer-explanation>
                    </span>
                </span>
            </div>
        </div>
    </span>

    <span *ngIf="concepts.length>0">
        <div>
            <h3 class='text-center'> Remember </h3>
            <ul class="concept-list">
                <span *ngFor="let concept of concepts; index as myCount">
                    <span *ngIf="concept.is_media_present==1">
                        <app-image-answer-concept
                            *ngFor="let myImage of concept.media_file_info"
                            [questionId]="question.server_question_id"
                            [mediaFileName]="myImage.media_file_name"
                            [conceptPartName]="concept.name">
                        </app-image-answer-concept>
                    </span>
                    <li *ngIf="concept.is_media_present!=1" class='concept-step' [innerHtml]="concept.body"></li>
                </span>
            </ul>
        </div>
    </span>


<span *ngIf="question.answerDescriptionVersion!=1" [innerHtml]="question.htmlExplanation"></span>
</div>
